import React from 'react';
import {
    makeStyles, TabList, Tab, Text, Spinner
} from '@fluentui/react-components';
import {
    Apps20Regular,
    NavigationPerson20Regular,
} from '@fluentui/react-icons';
import AdminLogout from "./AdminLogout";
import { useAdminAuth } from "./AdminAuthContext"
const useStyles = makeStyles({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '10px'
    },
    brand: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 8px 16px 8px'
    },
    nav: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '4px',
        margin: '8px 0',
        flex: 1,
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 8px 16px 8px'
    },
    logout: {
        width: '100%%'
    },
    icon: {
        fontSize: "clamp(1.1rem, 10vw, 1.1rem)",
        width: "1em",
        height: "1em"
    },
});

function AdminSidebar({ page, onNavigate }) {
    const s = useStyles();
    const { canManageCustomers, checkingManageAccess } = useAdminAuth();
    const go = (val) => () => onNavigate(val);

    return (
        <div className={s.root}>
            <div className={s.brand}>

                {/* <Call24Filled className={s.icon} /> */}
                <Text weight="semibold">Unaric Voice for Teams</Text>
            </div>

            <TabList vertical selectedValue={page} className={s.nav}>
                <Tab icon={<Apps20Regular />} value="authorization" onClick={go('authorization')}>Authorization</Tab>

                {checkingManageAccess ? (
                    <Spinner size="tiny" style={{ marginLeft: 4 }} />
                ) : canManageCustomers ? (
                    <Tab
                        icon={<NavigationPerson20Regular />}
                        value="manageCustomers"
                        onClick={go("manageCustomers")}
                    >
                        Manage Customers
                    </Tab>
                ) : (
                    <Tab
                        icon={<NavigationPerson20Regular />}
                        value="manageUsers"
                        onClick={go("manageUsers")}
                    >
                        Manage Users
                    </Tab>
                )}

                {/* <Tab icon={<People20Regular />} value="user" onClick={go('user')}>User Profile</Tab>
                <Tab icon={<ChatHelp20Regular />} value="help" onClick={go('help')}>Help</Tab> */}
            </TabList>

            <div className={s.footer}>
                <AdminLogout />
            </div>
        </div>
    );
}

export default AdminSidebar;
